export const getStyles = (isDark: boolean) => {
  const styles = {
    editor: {
      border: "1px solid #C4C4C4",
      borderRadius: "5px",
      padding: "10px",
      overflowY: "hidden",
    },
    toolbar: {
      backgroundColor: "#F8B043",
      borderRadius: "5px",
    },
    editorContainer: {
      img: {
        maxWidth: "100%",
      },
      ".rdw-editor-main": {
        background: "background.default",
        px: 4,
        minHeight: "150px",
        border: "1px solid lightgray",
        zIndex: 0,
        position: "relative",
      },
      ".rdw-editor-toolbar": {
        position: "sticky",
        top: "75px",
        visibility: "inherit !important",
        zIndex: 98,
      },
      figure: {
        m: 0,
      },
      ".public-DraftStyleDefault-block": {
        margin: "0px",
      },
      ".rdw-option-active": {
        backgroundColor: "rgb(223, 221, 221)",
        color: "#000000",
      },
    },
    button: {
      position: "absolute",
      top: 6,
      right: 6,
      width: 26,
      height: 26,
      borderRadius: "50%",
      border: "none",
      background: "rgba(0,0,0,0.6)",
      color: "#fff",
      cursor: "pointer",
      fontSize: 14,
      lineHeight: "26px",
      padding: 0,
      transition: "all 0.2s ease",
    },
    container: {
      position: "relative",
      display: "inline-block",
      maxWidth: "100%",
      minWidth: 120,
      minHeight: 90,
      verticalAlign: "top",
    },
  };
  return styles;
};
